import styled, { css } from 'styled-components';
import { BLACK_60 } from '../constants/colors';

export type DropdownSize = 'l' | 'm';

export const DropdownWrap = styled.div`
  position: relative;
`;

const triggerSize = {
  l: css`
    gap: 8px;
    font-size: 40px;
    line-height: 48px;
  `,
  m: css`
    gap: 4px;
    font-size: 24px;
    line-height: 30px;
  `,
};

const arrowSize = {
  l: css`
    svg {
      width: 32px;
      height: 32px;
    }
  `,
  m: css`
    svg {
      width: 24px;
      height: 24px;
    }
  `,
};

export const DropdownTrigger = styled.button<{ $size: DropdownSize }>`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  ${({ $size }) => triggerSize[$size]}
`;

export const DropdownTriggerLabel = styled.span<{ $underline?: boolean }>`
  color: var(--primary-base);
  text-decoration: ${({ $underline = true }) => ($underline ? 'underline' : 'none')};
  white-space: nowrap;
`;

export const DropdownArrow = styled.span<{ $open: boolean; $size: DropdownSize }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--primary-base);
  transform: rotate(${({ $open }) => ($open ? '90deg' : '-90deg')});
  transition: transform 0.15s ease-in-out;
  ${({ $size }) => arrowSize[$size]}

  svg {
    display: block;

    path {
      fill: currentColor;
    }
  }
`;

export const DropdownPanel = styled.div<{ $width: number }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: ${({ $width }) => `${$width}px`};
  box-sizing: border-box;
  max-height: min(320px, calc(100vh - 24px));
  overflow-y: auto;
  padding: 8px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 8px 18px 0 rgba(57, 78, 127, 0.16);
`;

export const DropdownOption = styled.button<{ $selected?: boolean; $bold?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 12px;
  background: ${({ $selected }) => ($selected ? 'var(--black-5)' : 'transparent')};
  color: var(--font-color);
  font-weight: ${({ $bold = true }) => ($bold ? 700 : 400)};
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: var(--black-5);
  }

  svg {
    display: block;
    flex-shrink: 0;
    width: 15px;
    height: 15px;

    path {
      fill: currentColor;
    }
  }
`;

export const DropdownEmpty = styled.div`
  padding: 10px 12px;
  color: ${BLACK_60};
  font-size: 16px;
  line-height: 22px;
`;
